export default {
  club_name: 'Färjestad BK',
  club_name_short: 'fbk',
  stadium_name: '',
  staging_url: 'https://fbk.api.fangroup.io',
  prod_url: 'https://fbk.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/fbk',
  club_logo: '/assets/teams/fbk.png',
  app_name: 'fbk',
  websale_name: 'fbk',
  ntb_team_id: 10034,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'fbk',
  monolithEnabled: false,
};
